import React from 'react';
import { useThemeColors } from '../../hooks/useTheme';
import './About.scss';
import s6 from '../../assets/images/s6.jpg';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
  const colors = useThemeColors();

  const stats = [
    { number: '15+', label: 'Projects' },
    { number: '5+', label: 'Years Experience' },
    { number: '10', label: 'Clients' }
  ];

  const coreSkills = {
    frontend: ['Angular', 'React.js', 'React Native', 'JavaScript', 'TypeScript', 'HTML5', 'CSS3', 'Bootstrap', 'Tailwind CSS', 'SCSS', 'Material UI'],
    backend: ['.NET Web API', 'Entity Framework', 'Node.js', 'Express.js'],
    database: ['SQL Server (SSMS)', 'MongoDB'],
    devops: ['CI/CD', 'Docker', 'AWS', 'Azure', 'Kubernetes', 'GitHub Actions', 'Git/SVN', 'Bitbucket'],
    design: ['Figma', 'Adobe XD', 'Photoshop', 'Lightroom', 'Material Design', 'Responsive Design'],
    api: ['RESTful APIs', 'Postman', 'Swagger'],
    salesforce: ['Salesforce Lightning', 'Apex', 'Visualforce']
  };

  return (
    <section 
      id="about" 
      className="about" 
      style={{ 
        '--background': colors.background,
        '--surface': colors.surface,
        '--surface1': colors.surface1,
        '--primary': colors.primary,
        '--text': colors.text,
        '--accent': colors.accent,
        '--border': colors.border,
      } as React.CSSProperties}
    >
      <div className="about__container">
        {/* Image and About Text Section */}
        <div className="about__top-section">
          <div className="about__image-container">
            <a href="#projects"  >
            <img src={s6} alt="Anantha Pradeep" className="about__image" 
            />
            </a>
          </div>
          
          <div className="about__content">
            <h2 className="about__title">About Me</h2>
            <p className="about__text">
              Results-driven Software Engineer with experience in full-stack development, 
              specializing in Angular, React Native, and modern front-end frameworks. Proficient in .NET Web API, 
              Entity Framework, and database management with expertise in DevOps practices, CI/CD pipelines, 
              and cloud deployments. Passionate about delivering scalable, high-performance, and user-centric 
              solutions with strong UI/UX design skills.
            </p>
            
            <div className="about__stats">
              {stats.map((stat, index) => (
                <div key={index} className="about__stat">
                  <span className="about__stat-number">{stat.number}</span>
                  <span className="about__stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Skills Section */}
        <div className="about__skills-container">
          <h3 className="about__skills-title">Technical Expertise</h3>
          
          <div className="about__skills-grid">
            {Object.entries(coreSkills).map(([category, skills]) => (
              <div className="about__skills-group" key={category}>
                <h4 className="about__skills-subtitle">
                  {category.charAt(0).toUpperCase() + category.slice(1).replace(/([A-Z])/g, ' $1')}
                </h4>
                <div className="about__skills-list">
                  {skills.map((skill, index) => (
                    <span key={index} className="about__skill">{skill}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;